<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :default-active="$route.path" :collapse="collapse" unique-opened :background-color="bgColor" text-color="#fff" :active-text-color="ThemeColor" router>
            <template v-for="item in Menu">
                <template v-if="item.subs">
                    <el-submenu :index="item.id" :key="item.id" v-if="item.subs.length>0">
                        <template slot="title">
                            <i :class="[ 'iconfont', item.icon ]"></i><span slot="title">{{ getLangMenu(item.title) }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-menu-item :index="subItem.path" :disabled="subItem.disabled || false" :key="subItem.id">
                                {{ getLangMenu(subItem.title) }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.path" :disabled="item.disabled || false" :key="item.id">
                        <i :class="[ 'iconfont', item.icon ]"></i><span slot="title">{{ getLangMenu(item.title) }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLangMenu } from '@/utils/getLangDict'
import bus from "@/utils/bus";
import config from '@/config'
export default {
    name: "vSidebar1",
    data() {
        return {
            collapse: false,
            Menu: [],
            ThemeColor: config.THEMECOLOR,
            bgColor: config.SIDEBARBGCOLOR,     //  左侧导航背景色
        };
    },
    created() {
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on("collapse", msg => {
            this.collapse = msg;
        });
    },
    computed: {
        ...mapGetters(["projectInfo", "roles", "mune","projectsystemInfo"])
    },
    watch: {
        // projectInfo(newVal) {
        //     this.fmtMenu(newVal.type_id);
        // },
		projectsystemInfo(newVal){
			this.fmtMenu(newVal.sys_type_id);
		}
    },
    methods: {
        getLangMenu,
        // 根据不同类型系统显示隐藏不同菜单
        fmtMenu(sys_type_id) {
            let menu = JSON.parse(JSON.stringify(this.mune))
            this.Menu = this.filterMenu(menu, sys_type_id);
        },
        filterMenu(menus, sys_type_id) {
            const accessedMenu = menus.filter(v => {
                if (this.hasMenuPermission(sys_type_id, v)) {
                    if (v.subs && v.subs.length) {
                        v.subs = this.filterMenu(v.subs, sys_type_id)
                    }
                    return true
                }
                return false
            })
            return accessedMenu
        },
        hasMenuPermission(sys_type_id, v) {
            if (v.system) {
                return v.system.indexOf(sys_type_id) >= 0
            } else {
                return true
            }
        }
    },
};
</script>

<style scoped lang="less">
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 60px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 250px;
}
.sidebar > ul {
    height: 100%;
}
.el-submenu [class^="iconfont"],
.el-menu-item [class^="iconfont"] {
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 16px;
    color: #fff;
}

</style>